import { Components } from '@ionic/core';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import React, { DOMAttributes, HTMLAttributes, ReactElement } from 'react';
import { i18nKeyType } from '../../../../../i18n';

export interface WidgetProps {
  key?: string;
  label?: string;
  description?: string;
  showDescription?: boolean;
  disabled?: boolean;
  ionItemProps?: Partial<Components.IonItem> &
    Partial<HTMLAttributes<HTMLIonItemElement>> &
    Partial<DOMAttributes<HTMLIonItemElement>>;
  extensions?: WidgetExtensions;
  subtitle?: string;
  subtitleColor?: string;
  isNested?: boolean;
  isPaywalled?: boolean;
  /**
   * Whether to use transparent background. Defaults to true.
   */
  transparentBackground?: boolean;
}

export interface WidgetExtensions {
  rightElement?: ReactElement;
}

export interface WidgetExtensionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: [FieldInputProps<any>, FieldMetaProps<any>, FieldHelperProps<any>];
  widgetRef: WidgetRef | null;
  setDisabled?: (disabled: boolean) => void;
  isDisabled?: boolean;
}

export const createWidgetExtension = (
  el: ReactElement | null | undefined,
  extensionProps: WidgetExtensionProps
): ReactElement | null => {
  if (el) {
    return React.cloneElement(el, { ...el.props, ...extensionProps });
  }

  return null;
};

export interface WidgetRef {
  disabled: boolean;
}

export interface NumericWidgetProps extends WidgetProps {
  step?: number;
}

export interface RatingWidgetProps extends WidgetProps {}

export interface TextWidgetProps extends WidgetProps {
  placeholder?: string;
  selectOnFocus?: boolean;
}

export interface SwitchWidgetProps extends WidgetProps {}
export interface BooleanWidgetProps extends WidgetProps {
  value: boolean;
}

export interface SliderWidgetProps extends WidgetProps {
  min: number;
  max: number;
  step: number;
  ticks?: boolean;
  snaps?: boolean;
}

export interface PickerWidgetProps<T = PickerOptionValue> extends WidgetProps {
  value?: string | number | Record<string, unknown>;
  options: PickerOption<T>[];
}

export type PickerOptionValue = boolean | string | number | object;

export interface PickerOption<T = PickerOptionValue> {
  value: T;
  label: i18nKeyType | string;
}

export enum NumericFormat {
  Percentage = 'percentage',
  Degree = 'degree',
}
